import { PRICE_DECIMALS } from '@/constants/solana';
import { roundSharesAmount } from '@/lib/orderbook';
import { useOrderbookStore } from '@/store/orderbook';

export const calculateSimpleModeShares = (
  price: number,
  minSize: number,
  isUsdc: boolean,
  tokenAmount?: string,
  usdcPerSolMinimum?: number,
): number => {
  if (!tokenAmount) return 0;
  const usdPrice = price / PRICE_DECIMALS;

  if (isUsdc) {
    const totalShares = +tokenAmount / usdPrice;
    return roundSharesAmount(totalShares, usdPrice, minSize);
  }

  if (!usdcPerSolMinimum) return 0;

  const totalCostUsd = +tokenAmount * usdcPerSolMinimum;

  return roundSharesAmount(totalCostUsd / usdPrice, usdPrice, minSize);
};

export const useSimpleModeShares = (
  price: number,
  minSize: number,
  tokenAmount?: string,
  usdcPerSolMinimum?: number,
): number => {
  const { isUsdc } = useOrderbookStore();

  return calculateSimpleModeShares(
    price,
    minSize,
    isUsdc,
    tokenAmount,
    usdcPerSolMinimum,
  );
};
